//import { authRoles } from 'app/auth';
//import MaterialUIComponentsNavigation from 'app/main/documentation/material-ui-components/MaterialUIComponentsNavigation';
// import { AiOutlineInfoCircle, AiTwotonePropertySafety } from "react-icons/ai";
// import { BiCctv } from "react-icons/bi";
// import { BsFillCameraVideoFill } from "react-icons/bs";
// import { FaTrello } from "react-icons/fa";
// import {CgCalendar} from "react-icons/cg";
// import { MdFormatBold, MdRouter, Md3DRotation } from "react-icons/md";
// import { RiGoogleFill } from "react-icons/ri";
// import { TiInfoOutline } from "react-icons/ti";
import i18next from 'i18next';
import jp from './navigation-i18n/jp';
import en from './navigation-i18n/en';
//import React from 'react';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('jp', 'navigation', jp);

let navigationConfig = [
	// {
	// 	id: 'Documentation',
	// 	title: 'Documentation',
	// 	type: 'group',
	// 	icon: 'star',
	// 	children: [
	// 		{
	// 			id: 'getting-started-doc',
	// 			title: 'Getting Started',
	// 			type: 'collapse',
	// 			icon: 'import_contacts',
	// 			children: [
	// 				{
	// 					id: 'installation-doc',
	// 					title: 'Installation',
	// 					type: 'item',
	// 					url: '/documentation/getting-started/installation'
	// 				},
	// 				{
	// 					id: 'installation-launching-project',
	// 					title: 'Launching Project',
	// 					type: 'item',
	// 					url: '/documentation/getting-started/launching'
	// 				}
	// 			]
	// 		},
	// 		{
	// 			id: 'working-with-fuse-react-doc',
	// 			title: 'Working with React',
	// 			type: 'collapse',
	// 			icon: 'import_contacts',
	// 			// children: [
	// 			// 	{
	// 			// 		id: 'development-doc',
	// 			// 		title: 'Development',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/development'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'environment-file-doc',
	// 			// 		title: 'Environment File',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/environment-file'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'documentation-icons',
	// 			// 		title: 'Icons',
	// 			// 		type: 'item',
	// 			// 		url: '/ui/icons'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'fuse-react-multi-language-doc',
	// 			// 		title: 'Multi Language',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/multi-language'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'production-doc',
	// 			// 		title: 'Production',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/production'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'theming-doc',
	// 			// 		title: 'Theming',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/theming'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'fuse-react-redux',
	// 			// 		title: 'Redux',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/redux'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'fuse-react-routing-doc',
	// 			// 		title: 'Routing',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/routing'
	// 			// 	},
	// 			// 	{
	// 			// 		id: 'fuse-react-code-splitting-doc',
	// 			// 		title: 'Code Splitting',
	// 			// 		type: 'item',
	// 			// 		url: '/documentation/working-with-fuse-react/code-splitting'
	// 			// 	},
	// 			// ]
	// 		},
			
	// 	]
	// },
	// {
	// 	type: 'divider',
	// 	id: 'divider-1'
	// },
	// {
	// 	id: 'switch',
	// 	title: 'switch',
	// 	translate: 'switch',
	// 	type: 'group',
	// 	icon: 'apps',
	// 	children: [
	// 		{
	// 			id: 'switch-to-admmin',
	// 			title: 'Homepage',
	// 			translate: 'SWITCH_TO_USER',
	// 			type: 'item',
	// 			icon: 'compare_arrows',
	// 			url: '/switch_user'
	// 		},
	// 	],
	// },
	// {	
	// 	id: 'isAdmin',
	// 	title: 'isAdmin',
	// 	translate: 'ISADMIN',
	// 	type: 'group',
	// 	icon: 'apps',
	// 	exact: true,
	// 	children: [
	// 		{
	// 			id: 'multipleCompanies',
	// 			title: 'Multiple Companies',
	// 			translate: 'MULTIPLE_COMPANIES',
	// 			type: 'item',
	// 			icon: 'work_outline',
	// 			url: '/multipleCompanies',
	// 			exact: true,
	// 		},
			
	// 		// {
	// 		// 	id: 'dashboard-admin',
	// 		// 	title: 'Dashboard',
	// 		// 	translate: 'DASHBOARD',
	// 		// 	type: 'item',
	// 		// 	icon: 'dashboard',
	// 		// 	url: '/dashboard/admin',
	// 		// 	exact: true
	// 		// },
	// 		{
	// 			id: 'addmember',
	// 			title: 'Add member',
	// 			translate: 'ADDMEMBER',
	// 			type: 'item',
	// 			icon: 'person_add',
	// 			url: '/members',
	// 			exact: true
	// 		},
	// 		{
	// 			id: 'projects',
	// 			title: 'Projects',
	// 			translate: 'ADDPROJECT',
	// 			type: 'item',
	// 			icon: 'tv',
	// 			url: '/projects',
	// 			exact: true,
	// 		},
	// 		// {
	// 		// 	id: 'mapping',
	// 		// 	title: 'Mapping',
	// 		// 	translate: 'MAPPING',
	// 		// 	type: 'item',
	// 		// 	icon: <FaNetworkWired />,
	// 		// 	url: '/mapping'
	// 		// },
	// 		{/*
	// 			id: 'Recycle',
	// 			title: 'Recycle',
	// 			translate: 'RECYCLE',
	// 			type: 'item',
	// 			icon: <FaRecycle />,
	// 			url: '/deleted-info'
	// 		*/},
	// 		{
	// 			id: 'initialization',
	// 			title: 'Initialization',
	// 			translate: 'INITIALIZATION',
	// 			type: 'item',
	// 			icon: 'domain',
	// 			url: '/initialization/0'
	// 		},
			
	// 		// {
	// 		// 	id: 'devicesettings',
	// 		// 	title: 'Device Settings',
	// 		// 	translate: 'DEVICESETTINGS',
	// 		// 	type: 'item',
	// 		// 	icon: 'settings',
	// 		// 	url: '/devices'
	// 		// },
			
	// 	]
	// },
	
	// 		// IS USER CATEGORY
	// 		{
	// 			id: 'is-user-no-group-selected',
	// 			title: 'isUser - no group selected',
	// 			type: 'group',
	// 			icon: 'web',
	// 			children: [
	// 				{
	// 					id: 'dashboard-user-no-group',
	// 					title: 'Home',
	// 					translate: 'HOME',
	// 					type: 'item',
	// 					icon: 'home',
	// 					url: '/dashboard/map',
	// 					exact: true
	// 				},
	// 				{
	// 					id: 'connect',
	// 					title: 'Connect',
	// 					translate: 'CONNECT',
	// 					type: 'item',
	// 					icon: 'chat',
	// 					url: '/chat'
	// 				},
	// 				{
	// 					id: 'live-stream',
	// 					title: 'Live Stream',
	// 					translate: 'LIVESTREAM',
	// 					type: 'item',
	// 					icon: 'movie_creation',
	// 					url: '/streaming/<uuid>'
	// 				},
	// 				{
	// 					id: 'download-stream',
	// 					title: 'Download Stream',
	// 					translate: 'DOWNLOADSTREAM',
	// 					type: 'item',
	// 					icon: 'cloud_download',
	// 					url: '/downloaded_stream'
	// 				},
	// 			]
	// 		},
	// 		// IS USER CATEGORY
	// 		{
	// 			id: 'is-user',
	// 			title: 'isUser - group is selected',
	// 			type: 'group',
	// 			icon: 'web',
	// 			children: [
	// 				{
	// 					id: 'dashboard-user',
	// 					title: 'Dashboard',
	// 					translate: 'DASHBOARD',
	// 					type: 'item',
	// 					icon: 'dashboard',
	// 					url: '/project-info',
	// 					exact: true
	// 				},
	// 				{
	// 					id: 'connectgroupselected',
	// 					title: 'Connect',
	// 					translate: 'CONNECT',
	// 					type: 'item',
	// 					icon: 'chat',
	// 					url: '/chat'
	// 				},
	// 				{
	// 					id: 'mix-calendar',
	// 					title: 'Mix Calendar',
	// 					translate: 'MIX_CALENDAR',
	// 					type: 'item',
	// 					icon: <CgCalendar />,
	// 					url: '/schedule/<uuid>'
	// 				},
	// 				{
	// 					id: 'livestream',
	// 					title: 'Live Stream',
	// 					translate: 'LIVE_STREAM',
	// 					type: 'item',
	// 					icon: 'movie_creation',
	// 					url: '/streaming/<uuid>'
	// 				},
	// 				{
	// 					id: 'downloadstream',
	// 					title: 'Download Stream',
	// 					translate: 'DOWNLOAD_STREAM',
	// 					type: 'item',
	// 					icon: 'cloud_download',
	// 					url: '/downloaded_stream'
	// 				},
	// 				{
	// 					id: 'contact',
	// 					title: 'Contact',
	// 					translate: 'CONTACT',
	// 					type: 'item',
	// 					icon: <AiOutlineInfoCircle />,
	// 					url: '/managerProfile/<uuid>'
	// 				},
	// 				{
	// 					id: 'ctm',
	// 					title: 'Ctm',
	// 					translate: 'CTM',
	// 					type: 'item',
	// 					icon: <AiOutlineInfoCircle />,
	// 					url: '/ctm'
	// 				},
	// 				{
	// 					id: 'cctv-map',
	// 					title: 'CCTV Map',
	// 					translate: 'CCTV_MAP',
	// 					type: 'item',
	// 					icon: <BiCctv/>,
	// 					url: '/project_map/<uuid>'
	// 				},
	// 				{
	// 					id: 'cctv',
	// 					title: 'CCTV',
	// 					translate: 'CCTV',
	// 					type: 'link',
	// 					icon: <BsFillCameraVideoFill />,
	// 					url: 'https://safie.link'
	// 				},
	// 				{
	// 					id: 'safety',
	// 					title: 'Safety',
	// 					translate: 'SAFETY',
	// 					type: 'link',
	// 					icon: <AiTwotonePropertySafety />,
	// 					url: 'https://153.149.159.17/andohazama/TP/TP001_Login.php'
	// 				},
	// 				{
	// 					id: 'buildee',
	// 					title: 'Buildee',
	// 					translate: 'BUILDEE',
	// 					type: 'link',
	// 					icon: <MdFormatBold />,
	// 					url: 'https://buildee.jp'
	// 				},
	// 				{
	// 					id: 'greensite',
	// 					title: 'Green Site',
	// 					translate: 'GREEN_SITE',
	// 					type: 'link',
	// 					icon: <RiGoogleFill />,
	// 					url: 'https://portal.kensetsu-site.com/login'
	// 				},
	// 				{
	// 					id: 'riskprediction',
	// 					title: 'Risk prediction',
	// 					translate: 'RISK_PREDICTION',
	// 					type: 'link',
	// 					icon: <TiInfoOutline />,
	// 					url: 'https://www.lbw.co.jp/kkymail/giken.html'
	// 				},
	// 				{
	// 					id: 'iot2d',
	// 					title: 'IOT (2D)',
	// 					translate: 'IOT2D',
	// 					type: 'link',
	// 					icon: <MdRouter />,
	// 					url: 'http://104.42.210.251/adhzm/index.asp'
	// 				},
	// 				{
	// 					id: 'iot3d',
	// 					title: 'IOT (3D)',
	// 					translate: 'IOT3D',
	// 					type: 'link',
	// 					icon: <Md3DRotation />,
	// 					url: 'http://powercubeorg.ddns.net/sensor_view/?site_id=1'
	// 				},
	// 				{
	// 					id: 'trello',
	// 					title: 'TRELLO',
	// 					type: 'link',
	// 					icon: <FaTrello />,
	// 					url: 'https://trello.com/b/IrkiLyod/react-work'
	// 				},
	// 			]
	// 		},
		]

export default navigationConfig;
